const styles = theme => ({
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1,
    },
    spacer: {
        padding: "10px",
    },
});

export default styles;